import { render, staticRenderFns } from "./PrescriptionMed.vue?vue&type=template&id=6a7c9cad&scoped=true"
import script from "./PrescriptionMed.vue?vue&type=script&lang=js"
export * from "./PrescriptionMed.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionMed.vue?vue&type=style&index=0&id=6a7c9cad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7c9cad",
  null
  
)

export default component.exports